module.exports = __webpack_public_path__ + "static/media/mca.b945bcf1.png";